<template>
  <div class="home-pannel" style="height: 100%;">
    <div class="home-pannel-title" style="display:flex;justify-content:space-between;">
      <div>
        <span>审批</span>
        <span>
          <a-badge v-if="counts>0" :count="counts" :showZero="true" style="top: -3px"></a-badge>
        </span>
      </div>
      <div class="paneltablepane" @click="seeMore">查看更多</div>
    </div>
    <div class="echarts" style="height: 92%;">
      <a-row style="height: 100%;">
        <a-col :span="24" style="height: 100%;">
          <div style="height: 100%;">
            <a-tabs default-active-key="0" @change="callback">
              <a-tab-pane
                v-for="item1 in tabs"
                style="height: 330px; overflow-y: auto;"
                :key="item1.key"
                :tab="item1.tab"
              >
                <template v-if="tablepane.length !== 0">
                  <div v-for="(item, index) in tablepane" :key="index">
                    <div style="margin-top: 10px">
                      <div style="display: flex">
                        <div style="position: relative; left: 8px">
                          <a-avatar size="large" icon="user" style="font-size: 11px" />
                        </div>
                        <div style="position: relative; left: 15px">
                          <span style="font-weight: 900; font-size: 15px">{{item.title}}</span>
                          <div style="margin-top: 10px">
                            <span style="opacity: 0.7">单据类型：</span>
                            <span
                              class="onClickStyle"
                              @click="documentsJump(item, 1)"
                            >{{ checkTypeObj[item.checkType] }}</span>
                          </div>
                          <div style="margin-top: 10px">
                            <span style="opacity: 0.7">对应客户：</span>
                            <span
                              class="onClickStyle"
                              @click="documentsJump(item, 2)"
                            >{{ item.customerName }}</span>
                          </div>
                          <div style="margin-top: 10px">
                            <span style="opacity: 0.7">申请时间：</span>
                            <span>{{ item.createTime }}</span>
                          </div>
                          <div style="margin-top: 10px">
                            <span style="opacity: 0.7">发 起 人：</span>
                            <span>{{ item.creator }}</span>
                          </div>
                          <div style="margin-top: 10px; color: burlywood">
                            <span>{{ item.apper }}</span>
                            <span>{{ item.process }}</span>
                          </div>
                        </div>
                        <div class="buttoned">
                          <a-button
                            v-if="item1.key === 1"
                            @click="approval(item)"
                            style="background-color: #52c41a; color: #fff"
                          >审核</a-button>
                        </div>
                      </div>
                    </div>
                    <div style="border: 1px solid rgb(233, 233, 233);margin-top: 10px;"></div>
                  </div>
                </template>
                <a-empty v-else style="margin-top: 6%" />
              </a-tab-pane>
              <a-tab-pane tab="抄送我的" :key="4" style="height: 330px; overflow-y: auto;">
                <template v-if="tablepane.length !== 0">
                  <div v-for="(item, index) in tablepane" :key="index">
                    <div style="margin-top: 10px">
                      <div style="display: flex">
                        <div style="position: relative; left: 8px">
                          <a-avatar size="large" icon="user" style="font-size: 11px" />
                        </div>
                        <div style="position: relative; left: 15px">
                          <span style="font-size: 15px">{{ item.title }}</span>
                          <div style="margin-top: 10px">
                            <span style="opacity: 0.7">单据类型：</span>
                            <!-- 费用报销 -->
                            <span
                              v-if="item.copyType === 58"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'financialManage/expenseReim/index')}}</span>
                            <!-- 回款计划 -->
                            <span
                              v-if="item.copyType === -13"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'contractManage/paymentPlan/index') }}</span>
                            <!-- 回款记录 -->
                            <span
                              v-if="item.copyType === 13"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'contractManage/paymentRecord/index') }}</span>
                            <!-- 付款计划 -->
                            <span
                              v-if="item.copyType === -36"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'purchase/paymentSchedule/index') }}</span>
                            <!-- 付款记录 -->
                            <span
                              v-if="item.copyType === 36"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'purchase/paymentRecords/index') }}</span>
                            <!-- 预支预付 -->
                            <span
                              v-if="item.copyType === 57"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >预支预付</span>
                            <!-- 采购单 -->
                            <span
                              v-if="item.copyType === 21"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'purchase/purchaseNote/index') }}</span>
                            <!-- 采购申请 -->
                            <span
                              v-if="item.copyType === 39"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'purchase/purchaseRequest/index') }}</span>
                            <!-- 收票记录 -->
                            <span
                              v-if="item.copyType === 40"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'financialManage/ticketReceiptRecord/index') }}</span>
                            <!-- 开票记录 -->
                            <span
                              v-if="item.copyType === 27"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'financialManage/billingRecords/index') }}</span>
                            <!-- 合同订单 -->
                            <span
                              v-if="item.copyType === 11"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'contractManage/contractOrder/index') }}</span>
                            <!-- 项目跟单 -->
                            <span
                              v-if="item.copyType === 47"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'projectManage/index') }}</span>
                            <!-- 大额申请 -->
                            <span
                              v-if="item.copyType === 999"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'financialManage/largeAmountApplication/index') }}</span>
                            <!-- 项目报备 -->
                            <span
                              v-if="item.copyType === 888"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'projectManage/laborAndMaterial/index') }}</span>
                            <!-- 节礼申请 -->
                            <span
                              v-if="item.copyType === 666"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'offices/courtesyApplication/index') }}</span>
                            <!-- 项目立项申请 -->
                            <span
                              v-if="item.copyType === 777"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'projectManage/projectProposals/index') }}</span>
                            <!-- 外出 -->
                            <span
                              v-if="item.copyType === 333"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'offices/travelRecords/index') }}</span>
                            <!-- 加班 -->
                            <span
                              v-if="item.copyType === 555"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'offices/overtimeRecords/index') }}</span>
                            <!-- 物资领用 -->
                            <span
                              v-if="item.copyType === 12"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'inventory/takeItBack/index') }}</span>
                            <span
                              v-if="item.copyType === 14"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'inventory/returnWarehouse/index') }}</span>
                            <!-- 销售机会 -->
                            <span
                              v-if="item.copyType === 16"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'salesOpportunities/projectOpportunities/index') }}</span>
                            <!-- 待办任务 -->
                            <span
                              v-if="item.copyType === 15"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'salesOpportunities/todoTask/index') }}</span>
                            <!-- 合同增补核减 -->
                            <span
                              v-if="item.copyType === 17"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'contractManage/contractManagement/index') }}</span>
                            <!-- 招聘需求 -->
                            <span
                              v-if="item.copyType === 48"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'manpower/recruitmentDemand/index') }}</span>
                            <!-- 保证金 -->
                            <span
                              v-if="item.copyType === 49"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'contractManage/earnestMoney/index') }}</span>
                            <span
                              v-if="item.copyType === 50"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'offices/vehicleDepartureRecord/index') }}</span>
                            <span
                              v-if="item.copyType === 51"
                              @click="titleClick(item, 1)"
                              class="onClickStyle"
                            >{{ tree(tableListType, 'offices/returnCarRecord/index') }}</span>

                            <!-- <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 58">费用报销</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === -13">回款计划</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 13">回款记录</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === -36">付款计划</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 36">付款记录</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 57">预支预付</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 21">采购单</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 39">采购申请</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 8">收票记录</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 27">开票记录</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 11">合同订单</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 47">项目</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 999">大额申请</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 888">项目报备</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 666">节礼申请</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 777">项目立项申请</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 12">物资领用</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 333">外出</span>
                            <span class="onClickStyle" @click="titleClick(item, 1)" v-if="item.copyType === 555">加班</span>-->
                            <!-- <span
                              class="onClickStyle"
                              @click="titleClick(item, 1)"
                            >{{ justeds[item.copyType] }}</span>-->
                          </div>
                          <div style="margin-top: 10px">
                            <span style="opacity: 0.7">对应客户：</span>
                            <span
                              class="onClickStyle"
                              @click="titleClick(item, 2)"
                            >{{ item.customerName }}</span>
                          </div>
                          <div style="margin-top: 10px">
                            <span style="opacity: 0.7">申请时间：</span>
                            <span>{{ item.createTime }}</span>
                          </div>
                          <div style="margin-top: 10px">
                            <span style="opacity: 0.7">发 起 人：</span>
                            <span>{{ item.creator }}</span>
                          </div>
                          <div style="margin-top: 10px; color: burlywood">
                            <span>{{ item.apper }}</span>
                            <span>{{ item.process }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style="border: 1px solid rgb(233, 233, 233);margin-top: 10px;"
                      v-if="index === 0"
                    ></div>
                  </div>
                </template>
                <a-empty v-else style="margin-top: 6%" />
              </a-tab-pane>
            </a-tabs>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { tree } from '@/utils/getMuneList'
export default {
  data () {
    return {
      counts: '',
      tableListType: JSON.parse(localStorage.getItem('USER_ROUTER'))[0].children,
      tabs: [
        {
          tab: '待我审批',
          key: 1
        },
        {
          tab: '我发起的',
          key: 2
        },
        {
          tab: '我已审批',
          key: 3
        }
      ],
      countType: 0,
      checkTypeList: [],
      checkTypeObj: {},
      justs: [
        tree(this.tableListType, 'financialManage/expenseReim/index'),
        tree(this.tableListType, 'purchase/purchaseNote/index'),
        '预支预付',
        tree(this.tableListType, 'purchase/paymentSchedule/index'),
        tree(this.tableListType, 'contractManage/paymentRecord/index'),
        tree(this.tableListType, 'offices/travelRecords/index'),
        tree(this.tableListType, 'offices/overtimeRecords/index'),
        tree(this.tableListType, 'financialManage/largeAmountApplication/index'),
        tree(this.tableListType, 'projectManage/projectProposals/index'),
        tree(this.tableListType, 'offices/courtesyApplication/index'),
        tree(this.tableListType, 'inventory/takeItBack/index'),
        tree(this.tableListType, 'purchase/purchaseRequest/index'),
        tree(this.tableListType, 'purchase/returnWarehouse/index'),
        tree(this.tableListType, 'salesOpportunities/todoTask/index'),
        tree(this.tableListType, 'salesOpportunities/projectOpportunities/index'),
        tree(this.tableListType, 'contractManage/contractManagement/index'),
        tree(this.tableListType, 'manpower/recruitmentDemand/index'),
        tree(this.tableListType, 'contractManage/earnestMoney/index'),
        tree(this.tableListType, 'offices/vehicleDepartureRecord/index'),
        tree(this.tableListType, 'offices/returnCarRecord/index')
      ],

      justeds: [
        '费用报销',
        '回款计划',
        '回款记录',
        '付款计划',
        '付款记录',
        '预支预付',
        '采购单',
        '采购申请',
        '收票记录',
        '开票记录',
        '合同订单',
        '大额申请',
        '项目立项申请',
        '节礼申请',
        '物资领用',
        '加班',
        '外出',
        '招聘需求',
        '保证金',
        '出车登记',
        '还车记录'
      ],
      tablepane: [],
      userId: this.$store.state.account.user.userId
    }
  },
  created () {
    this.initDectData()
  },
  beforeMount () {
    this.approvalFrtch({ status: 4, userId: this.userId }, 1)
    // this.checkDataTypeObj = this.$store.state.account.dictData.checkDataTypeObj
    // console.log('this.checkDataTypeObj =>', this.checkDataTypeObj)
  },
  methods: {
    tree,
    seeMore () {
      // this.$emit('seeMored', this.countType)
      switch (this.countType) {
        case 0:
        case 1:
          this.$router.push({ path: 'approvalManage/approvalData', query: { type: 4 } })
          break
        case 2:
          this.$router.push({ path: 'approvalManage/approvalData' })
          break
        case 3:
          this.$router.push({ path: 'approvalManage/approvalData', query: { type: -1 } })
          break
        case 4:
          this.$router.push({ path: 'offices/copyMessage1', query: { type: 1 } }) // 抄送信息
          break
      }
    },
    approval (value) {
      this.$emit('approvaled', value)
    },
    async initDectData () {
      let res = await this.$get('/common/dict/getListByEn', { dictTypeEn: 'checkDataType' })
      if (res.data.status === 1) {
        let resData = res.data.data
        resData.forEach(item => {
          this.checkTypeObj[item.dictTypeEn] = item.dictName
        })
        this.$forceUpdate()
      } else {
        this.$message.warning(res.data.message)
      }
    },
    callback (key) {
      this.countType = key
      this.tablepane = []
      this.counts = ''
      if (key === 1) {
        this.approvalFrtch({ status: 4, userId: this.userId })
      } else if (key === 2) {
        this.approvalFrtch({ step: 0, userId: this.userId })
      } else if (key === 3) {
        this.approvalFrtch({ userId: this.userId })
      } else if (key === 4) {
        this.$get('/copy/list', { type: 1 }).then((res) => {
          if (res.data.data.rows.length > 0) {
            this.tablepane = res.data.data.rows
          }
          this.counts = res.data.data.total
        })
      }
    },
    approvalFrtch (type) {
      this.$get('checkDetail/listForHome', { ...type }).then((res) => {
        this.tablepane = res.data.data.rows
        this.counts = res.data.data.total
      })
    },
    documentsJump (rowVal, num) {
      this.$emit('documentsJumped', { rowVal: rowVal, num: num })
    },
    titleClick (rowVal, num) {
      this.$emit('titleClick', rowVal, num)
    }
    // 点审批
    // approvaled (value) {
    //   this.auditVisible = true
    //   this.$nextTick(() => {
    //     this.$refs.auditRef.setId(value)
    //   })
    // },
    // 查看更多
    // seeMored (count) {
    //   this.seeMore(count)
    // },
    // 点击详情
    // documentsJumped (item) {
    //   this.documentsJump(item.rowVal, item.num)
    // },
  }
}
</script>

<style lang="less" scoped>
.buttoned {
  position: relative;
  left: 24%;
  margin-top: 70px;
}
.panel {
  padding-bottom: 0.6rem;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 10px;

  .panel-title {
    width: 100%;
    border-bottom: solid 1px #e9e9e9;
    line-height: 50px;
    padding-left: 15px;
    position: relative;

    &::before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 30px;
      background-color: #0079fe;
      position: absolute;
      left: 0;
      top: 10px;
      border-radius: 4px;
    }

    span {
      &:first-child {
        font-size: 18px !important;
        font-weight: 400;
      }
    }
  }

  .readNewspaper {
    display: flex;
    position: relative;
    margin: 30px 0px 30px 0px;
    padding-left: 30px;
    padding-right: 0px;

    .ico {
      display: inline-block;
      background-color: #0089fe;
      border-radius: 38%;
      width: 50px;
      height: 50px;
      line-height: 50px;
      color: #ffffff;
      text-align: center;
      font-size: 20px;
      // position: relative;
      // top: 6px;
    }

    .value {
      margin-left: 0.6rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      span {
        font-size: 14px;
        color: #797979;

        &:first-child {
          font-size: 22px;
          color: #333333;
        }
      }
    }
  }

  .fontContent {
    border: 1px solid #e1e1e1;
    height: 10px;
    border-radius: 20px;
    letter-spacing: 0px;
    font-size: 14px;
    font-weight: 500;
    position: relative;
    left: 70%;
    padding: 2px 4px;
    cursor: pointer;
  }
  .noticeList {
    padding: 16px 15px;

    .notice {
      display: flex;
      cursor: pointer;
      justify-content: space-between;

      .notice-title {
        font-size: 14px;
        color: #333333;
        margin-bottom: 5px;
      }

      .notice-content {
        font-size: 12px;
        color: #797979;
      }
    }
  }
}
.paneltablepane {
  border: 1px solid #e1e1e1;
  height: 30px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  margin-top: 10px;
  margin-right: 10px;
  padding: 0 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.paneltablepane:hover {
  background-color: #e9e9e9;
}
</style>



// WEBPACK FOOTER //
// src/components/homeComponents/approve.vue